import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import uploadFolder from '../../images/upload-folder.svg';
import paperclip from '../../images/paperclip.svg';
import styles from '../../styles/FormFileUpload.module.scss';

const cx = classNames.bind(styles);

const EnrollmentFormFileUpload = ({ name, title, helpText, accept, defaultValue, inputRef, onChange }) => {
  const [filename, setFilename] = useState(defaultValue);

  const onFileUpload = (event) => {
    const { files } = event.target;
    if (files && files[0]) {
      setFilename(files[0].name);
    }
    if (onChange) {
      onChange();
    }
  };

  return (
    <label htmlFor={name} className={cx('EnrollmentFormFileUpload', { fileUploaded: filename })}>
      <input name={name} id={name} type="file" accept={accept} ref={inputRef} onChange={onFileUpload} />
      {filename ? (
        <div className={styles.fileUploaded}>
          <img alt={title} src={paperclip} />
          <span className={styles.title}>{filename}</span>
        </div>
      ) : (
        <div className={styles.uploadContent}>
          <img alt={title} src={uploadFolder} />
          <span className={styles.title}>{title}</span>
          <span className={styles.helpText}>{helpText}</span>
        </div>
      )}
    </label>
  );
};

EnrollmentFormFileUpload.defaultProps = {
  helpText: null,
  defaultValue: null,
  onChange: null,
};

EnrollmentFormFileUpload.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  accept: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func,
};

export default EnrollmentFormFileUpload;
